import type { Building } from '@map/shared';
import { STAGE_NAMES, stageOf } from '../globe/Rain.js';

/**
 * A faculty's country: how much of its quiz is held, and the weather that
 * makes over it. Ilm is where the quiz is taken; this only reports it.
 */
export function FacultyCard({ building }: { building: Building }) {
  const f = building.faculty;
  if (!f) return null;
  const percent = Math.round(f.score * 100);
  const stage = stageOf(f.score);
  return (
    <div className="flex flex-col gap-3 text-sm">
      <header>
        <p className="text-base font-medium">{building.name}</p>
        <p className="text-text-muted">
          Stage {stage} of 10 · {STAGE_NAMES[stage]}
        </p>
      </header>
      <div>
        <div className="mb-1 flex justify-between text-xs text-text-muted">
          <span>Quiz held</span>
          <span className="tabular-nums">{percent}%</span>
        </div>
        <div className="h-2 overflow-hidden rounded-full bg-surface-1">
          <div className="h-full rounded-full" style={{ width: `${percent}%`, background: 'var(--accent)' }} />
        </div>
      </div>
      <p className="text-text-muted">
        {f.questions === 0
          ? 'No quiz questions in this faculty yet.'
          : `${f.correct} of ${f.questions} questions right on their latest answer · ${f.questions - f.answered} not answered yet`}
      </p>
      <a className="text-xs underline" href="https://ilm.mappedself.com/quiz" target="_blank" rel="noreferrer">
        Take the quiz in Ilm
      </a>
    </div>
  );
}
